import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import { getApiUrl } from "utils";
import {
  getRequestTypeStage,
  getRequestTypeDocs,
  getBankStageApi,
  checkPrevBankApi,
  createBankModifyRequestApi,
} from "designs/v1/pages/ModifyKyc/services";

const CheckPrevRequest = ({
  stageScreen,
  setStageScreen,
  setStep,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [requestData, setRequestData] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    const checkPrevBank = async () => {
      let payload = {
        request_type: stageScreen,
        client: activeUserDetail.client,
        pan_no: activeUserDetail.poi?.[0]?.pan_number,
        active_mobile_no: activeUserDetail.phone,
        active_kyc: activeUserDetail.name,
        bank_modification_type: localStorage.getItem("BankRequestType"),
      };
      try {
        const resp = await checkPrevBankApi(payload);
        console.log("resp", resp.data?.data);
        setIsLoading(false);
        if (["PENDING", "INPROGRESS"].includes(resp.data?.data?.status)) {
          setRequestData(resp.data?.data);
          localStorage.setItem(
            "BankRequestNumber",
            resp.data?.data?.rekyc_modi_request_name
          );
        } else {
          handleCreateRequest();
        }
      } catch (error) {
        setIsLoading(false);
        console.log("error", error);
      }
    };
    checkPrevBank();
  }, []);

  const getModifyStage = async () => {
    setIsLoading(true);
    try {
      let payload = { request_type: stageScreen };
      payload["doc_name"] = localStorage.getItem("BankRequestNumber");
      payload["bank_modification_type"] =
        localStorage.getItem("BankRequestType");
      const resp = await getBankStageApi(payload);
      let stageList = resp.data?.data?.RekycRequests_flow_status || [];
      let pageName = 0;
      for (let index = 0; index < stageList.length; index++) {
        const element = stageList[index];
        if (pageName === 0) {
          if (element?.changes_in_which_account_data?.status === 0) {
            pageName = "DematUccForm";
          } else if (element?.modification_details?.status === 0) {
            pageName = "CreateRequest";
          } else if (element?.account_setted_as_primary?.status === 0) {
            pageName = "UpdatePrimaryBank";
          } else if (element?.review?.status === 0) {
            pageName = "BankModificationReview";
          } else if (
            element?.requested_for__esignature?.status === 0 ||
            element?.requested_for__esignature?.status === 1
          ) {
            pageName = "BankModificationESignature";
          }
        }
      }
      setIsLoading(false);
      return pageName;
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const handleCreateRequest = async () => {
    setIsLoading(true);
    const requestTypes = getRequestTypeStage();
    const payload = {
      request_type: stageScreen,
      full_name: activeUserDetail.full_name,
      client: activeUserDetail.client,
      active_mobile_no: activeUserDetail.phone,
      active_email_id: activeUserDetail.email,
      active_pan: activeUserDetail.poi?.[0]?.pan_number,
      active_kyc: activeUserDetail.name,
      bank_modification_type: localStorage.getItem("BankRequestType"),
      multiple_modification: requestTypes?.length ? 1 : 0,
      doctype_name: activeUserDetail.doctype,
      existing_customer: activeUserDetail.existing_customer,
    };
    try {
      const resp = await createBankModifyRequestApi(payload);
      setIsLoading(false);
      if (!resp.data?.data?.request_number) {
        return toast.error("Internal server error!");
      }
      localStorage.setItem(
        "BankRequestNumber",
        resp.data?.data?.request_number
      );
      setStep("DematUccForm");
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const onSubmit = async (value) => {
    if (value === "Yes") {
      const docName = localStorage.getItem("BankRequestNumber");
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(docName);
      if (requestTypes && requestTypes.length > 0) {
        const resp = await getModifyStage();
        if (
          !["BankModificationReview", "BankModificationESignature"].includes(
            resp
          )
        ) {
          return setStep(resp);
        }
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        if (requestTypes.length === 0) {
          return setStageScreen("MultipleRequestTypes");
        }
        setStageScreen(requestTypes[0]);
      } else {
        const resp = await getModifyStage();
        setIsContinue(true);
        setStep(resp);
      }
    } else {
      handleCreateRequest();
    }
  };

  return (
    <div>
      <Title title="Bank Modification Request" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          {requestData && (
            <div>
              {/* <div className="row mt-4">
                <h5 className="text-bold m-0">Doctype name</h5>
                <div className="row">
                  <div className="col-sm">{requestData.doctype_name}</div>
                </div>
              </div> */}
              {/* <div className="row mt-4">
                <h5 className="text-bold m-0">User Details</h5>
                <div className="row mt-1">
                  <div className="col-sm">Account Type</div>
                  <div className="col-sm">{requestData.account_type}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Account Number</div>
                  <div className="col-sm">{requestData.ac_number}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">IFSC code</div>
                  <div className="col-sm">{requestData.ifsc}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Account Name</div>
                  <div className="col-sm">{requestData.account_name}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Bank Name</div>
                  <div className="col-sm">{requestData.bank_name}</div>
                </div>
                <div className="row mt-1">
                  <div className="col-sm">Branch Name</div>
                  <div className="col-sm">{requestData.branch}</div>
                </div>
              </div> */}
              <div className="row mt-4">
                <h5 className="text-bold m-0">Modification Bank Details</h5>
                <div className="row my-1">
                  <div className="col-sm">Request Type</div>
                  <div className="col-sm">
                    {requestData?.modification_request_type}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm">Request Number</div>
                  <div className="col-sm">
                    {requestData.rekyc_modi_request_name}
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <h5 className="text-bold m-0">New Bank Details</h5>
                {!requestData?.bank_details?.length ? (
                  <>
                    <div className="row my-1">
                      <div className="col-sm">Name</div>
                      <div className="col-sm">{requestData?.account_name}</div>
                    </div>
                    <div className="row my-1">
                      <div className="col-sm">Account Type</div>
                      <div className="col-sm">{requestData?.account_type}</div>
                    </div>
                    <div className="row my-1">
                      <div className="col-sm">Account Number</div>
                      <div className="col-sm">{requestData?.ac_number}</div>
                    </div>
                    <div className="row my-1">
                      <div className="col-sm">Bank Name</div>
                      <div className="col-sm">{requestData?.bank_name}</div>
                    </div>
                    <div className="row my-1">
                      <div className="col-sm">Branch Name</div>
                      <div className="col-sm">{requestData?.branch}</div>
                    </div>
                    <div className="row my-1">
                      <div className="col-sm">IFSC code</div>
                      <div className="col-sm">{requestData?.ifsc}</div>
                    </div>
                    {requestData?.upload_cancelled_cheque && (
                      <div className="row my-1">
                        <div className="col-sm">Cheque Image</div>
                        <div className="col-sm">
                          <img
                            src={`${getApiUrl()}/${
                              requestData?.upload_cancelled_cheque
                            }`}
                            width="200"
                            alt=""
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {requestData?.bank_details?.length > 0 && (
                      <>
                        <table className="table mx-2">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Account Type</th>
                              <th scope="col">Account Number</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Branch</th>
                              <th scope="col">IFSC Code</th>
                              <th scope="col">Primary Bank</th>
                            </tr>
                          </thead>
                          <tbody>
                            {requestData.bank_details
                              .filter(
                                (item) => item.verified_bank_account === 1
                              )
                              .map((item, idx) => {
                                return (
                                  <tr key={idx}>
                                    <td>{item.name}</td>
                                    <td>{item.account_type || "-"}</td>
                                    <td>{item.account_number}</td>
                                    <td>{item.bank_name}</td>
                                    <td>{item.branch}</td>
                                    <td>{item.ifsc}</td>
                                    <td>
                                      {item.is_primary_bank_account === 1
                                        ? "Yes"
                                        : "No"}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="row mt-4">
                <div className="row my-1">
                  <div className="col-sm text-bold">Status</div>
                  <div className="col-sm">{requestData.status}</div>
                </div>
              </div>
            </div>
          )}
          {!isLoading && (
            <div className="d-flex mt-4">
              <div className="">
                <Button
                  type="button"
                  title="Back"
                  handleClick={() => setStep("ActiveUserInfo")}
                  disabled={isLoading}
                />
              </div>
              <div className="mx-2">
                <Button
                  title="Create new request"
                  handleClick={() => onSubmit("No")}
                  loading={isLoading}
                />
              </div>
              <div className="">
                <Button
                  title="Continue"
                  handleClick={() => onSubmit("Yes")}
                  loading={isLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckPrevRequest;
